import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
})
export class SideMenu {
  title = input.required<string>();
  logo = input<string>();
  collapsed = input<boolean>(false);
  toggleCollapse = output<void>();
}
